import React, { Component } from 'react';
import { safeOnClick } from '@/util/helpers/event-helpers';

class Toggle extends Component {
  onToggle = () => {
    if (this.props.disabled) {
      return null;
    }
    this.props.onChange(!this.props.value);
  };

  render() {
    const { value, className, disabled } = this.props;

    const addedClass = className || '';

    return (
      <label
        className={`${
          disabled ? 'toggle-disabled ' : ''
        }toggle-switch ${addedClass}`}
        onClick={safeOnClick(this.onToggle)}
      >
        <input type="checkbox" checked={value} readOnly />
        <span className="toggle-slider toggle-round" />
      </label>
    );
  }
}

export default Toggle;
